import React from 'react';

import { Skeleton } from '@mui/material';

import CommitForm from '../../../../../components/CommitForm';
import ContentCard from '../../../../../components/ContentCard';
import { useUpdateCourseMutation } from '../../../../../services/courses';
import { Course } from '../../../../../services/courses/types';
import useError from '../../../../../utils/react/hooks/useError';

interface XeroDetailsCardProps {
  data?: Course,
}

const XeroDetailsCard = ({ data }: XeroDetailsCardProps) => {
  const [updateCourse, {
    isLoading: isUpdateCourseLoading,
    isError: isUpdateCourseError,
    error: updateCourseError,
  }] = useUpdateCourseMutation();

  useError(isUpdateCourseError, updateCourseError);

  if (!data) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Term Details">
      <CommitForm
        data={{
          xeroTermCode: data.xeroCodes?.TERM.code,
          xeroTermAmount: data.xeroCodes?.TERM.amount,
          xeroExtraCode: data.xeroCodes?.EXTRA.code,
          xeroExtraAmount: data.xeroCodes?.EXTRA.amount,
          xeroCreditCode: data.xeroCodes?.CREDIT.code,
          xeroCreditAmount: data.xeroCodes?.CREDIT.amount,
        }}
        metadata={{
          xeroTermCode: {
            label: 'Term Code',
            editable: true,
            type: 'text',
          },
          xeroTermAmount: {
            label: 'Term Amount',
            editable: true,
            type: 'number',
          },
          xeroExtraCode: {
            label: 'Extra Code',
            editable: true,
            type: 'text',
          },
          xeroExtraAmount: {
            label: 'Extra Amount',
            editable: true,
            type: 'number',
          },
          xeroCreditCode: {
            label: 'Credit Code',
            editable: true,
            type: 'text',
          },
          xeroCreditAmount: {
            label: 'Credit Amount',
            editable: true,
            type: 'number',
          },
        }}
        fields={{
          xeroTermCode: {
            xs: 12,
            md: 6,
          },
          xeroTermAmount: {
            xs: 12,
            md: 6,
          },
          xeroExtraCode: {
            xs: 12,
            md: 6,
          },
          xeroExtraAmount: {
            xs: 12,
            md: 6,
          },
          xeroCreditCode: {
            xs: 12,
            md: 6,
          },
          xeroCreditAmount: {
            xs: 12,
            md: 6,
          },
        }}
        onSubmit={async (values) => updateCourse({
          courseId: data.id,
          newAttributes: {
            xeroCodes: {
              TERM: {
                code: values?.xeroTermCode || data.xeroCodes?.TERM.code,
                amount: values?.xeroTermAmount || data.xeroCodes?.TERM.amount,
              },
              EXTRA: {
                code: values?.xeroExtraCode || data.xeroCodes?.EXTRA.code,
                amount: values?.xeroExtraAmount || data.xeroCodes?.EXTRA.amount,
              },
              CREDIT: {
                code: values?.xeroCreditCode || data.xeroCodes?.CREDIT.code,
                amount: values?.xeroCreditAmount || data.xeroCodes?.CREDIT.amount,
              },
            },
          },
        })}
        isSubmitLoading={isUpdateCourseLoading}
      />
    </ContentCard>
  );
};

export default XeroDetailsCard;
